export default __webpack_public_path__ + "static/media/amazon_ad.f2ef0cfc.jpg";